export default __webpack_public_path__ + "static/media/i-circule-small.1970e828.svg";